import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";
import { xssFilter } from "../../common/utils/xssFilter";

//temp component, before html is refactored
function ArticleOfferTitle(props) {
    const data = props.data ? props.data.properties || {} : null;
    if (!data) {
        return "";
    }
    const dataProps = extractProps(props);

    return (
        <div className="un-article-content-panel">
            <div className="tq-main-color-bg un-article-main-accent">
                <div className="un-article-main-accent-content">
                    <p className="tq-panel-title tq-title-background">{dataProps.range}</p>
                    <div className="tq-text-content">
                        <h1
                            dangerouslySetInnerHTML={{
                                __html: xssFilter.process(dataProps.text)
                            }}
                            data-hyperlinks-container={true}
                        />
                    </div>
                </div>

                <div className="un-article-main-accent-img">
                    <img src={dataProps.image} alt={dataProps.alt} />
                </div>
            </div>
        </div>
    );
}

function extractProps(props) {
    const data = props.data || {};
    const siren = EntityBuilder.of(data);
    const title = siren.getChild("title");
    const rangeTitle = siren.getChild("range-title");
    const imageEntity = siren.getChild("image");

    return {
        range: rangeTitle.getValue(),
        text: title.getValue(),
        image: imageEntity.getProperty("src"),
        alt: imageEntity.getProperty("alt")
    };
}

export default webui.connectComponent()(ArticleOfferTitle);
